import { render, staticRenderFns } from "./w-contact-us.vue?vue&type=template&id=9f34b78a"
import script from "./w-contact-us.vue?vue&type=script&lang=js"
export * from "./w-contact-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports